export const categories = [
  {
    id: '1',
    slug: 'star-gossip',
    name: '明星八卦',
    description: '明星最新动态、绯闻爆料、私生活揭秘',
    icon: 'ri-star-line',
  },
  {
    id: '2',
    slug: 'influencer-expose',
    name: '网红曝光',
    description: '网红真实面貌、直播翻车、人设崩塌',
    icon: 'ri-camera-line',
  },
  {
    id: '3',
    slug: 'industry-insider',
    name: '娱乐圈内幕',
    description: '行业潜规则、幕后故事、圈内人爆料',
    icon: 'ri-eye-line',
  },
  {
    id: '4',
    slug: 'hot-trending',
    name: '热议话题',
    description: '全网热议事件追踪、深度分析解读',
    icon: 'ri-fire-line',
  },
  {
    id: '5',
    slug: 'throwback',
    name: '考古翻旧',
    description: '经典爆料回顾、历史黑料盘点',
    icon: 'ri-history-line',
  },
  {
    id: '6',
    slug: 'daily-fresh',
    name: '每日鲜瓜',
    description: '每日最新爆料速递、24小时热门',
    icon: 'ri-timer-line',
  },
];